module.exports = __webpack_public_path__ + "img/reply.0ebad0be.svg";